export enum WEBSOCKET_ACTION_TYPE {
  SUBSCRIBE = "subscribe",
  UNSUBSCRIBE = "unsubscribe",
}
